/**
 * Returns true when any site under a project has a non-empty
 * `specialSiteCondition`. Used by multi-bid / multi-accept dialogs to drive
 * the "Site level" wording on the requirements-acknowledgement checkbox
 * without rendering each site's requirement text.
 */
export function projectHasSiteRequirements(project: any): boolean {
  return !!project?.sites?.some(
    (s: any) => !!s?.site?.specialSiteCondition?.trim()
  );
}
